import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  orderTotal: null,
  loading: false,
  error: null
};

const orderSummarySlice = createSlice({
  name: 'orderSummary',
  initialState,
  reducers: {
    
    setOrderTotal: (state, action) => {
      state.orderTotal = action.payload;
      state.loading = false;
    },
    
    setLoading: (state) => {
      state.loading = true;
    },
    
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    }
  }
});

export const { setOrderTotal, setLoading, setError } = orderSummarySlice.actions;

export default orderSummarySlice.reducer;
